import { render, staticRenderFns } from "./profitsByInvoices.vue?vue&type=template&id=067ee584"
import script from "./profitsByInvoices.vue?vue&type=script&lang=js"
export * from "./profitsByInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports